import { toast } from 'sonner';
import { supabase } from '@/integrations/supabase/client';

/**
 * Log an error toast to the client_errors table and show a toast.
 * Falls back silently if the DB insert fails — never blocks the user.
 */
export function logErrorToast(
  message: string,
  opts?: {
    page?: string;
    component?: string;
    metadata?: Record<string, unknown>;
  }
) {
  // Always show the toast immediately
  toast.error(message);

  // Fire-and-forget: log to DB
  supabase.auth.getUser().then(({ data }) => {
    const userId = data?.user?.id;
    if (!userId) return;
    supabase
      .from('client_errors')
      .insert({
        user_id: userId,
        message,
        page: opts?.page || (typeof window !== 'undefined' ? window.location.pathname : null),
        component: opts?.component || null,
        metadata: opts?.metadata || {},
      })
      .then(() => {});
  });
}
